<template>
    <div v-if="model.general_setting">
        <h4 class="group__headline">Settings</h4>
        <el-form-item label="Failed products import email">
            <el-input
                v-model="model.general_setting.failed_import_notifier"
            ></el-input>
        </el-form-item>
        <el-form-item label="Domain">
            <el-input v-model="model.general_setting.domain"></el-input>
        </el-form-item>
        <el-form-item label="Main email">
            <el-input v-model="model.general_setting.email"></el-input>
            <template v-for="(data, index) in modelOrigin">
                <div
                    v-if="
                        data.setting_key === 'email' &&
                        origins.length &&
                        isValidOrigin(data.origin_id)
                    "
                    class="mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
                >
                    <div class="flex">
                        <div class="grow-0 shrink-0 basis-32">
                            Setting for {{ getOriginName(data.origin_id) }}
                        </div>
                        <el-input
                            v-model="modelOrigin[index].setting"
                        ></el-input>
                    </div>
                    <div class="flex justify-end mt-4">
                        <el-button
                            type="primary"
                            @click="
                                onSubmitOriginSetting(
                                    data.id,
                                    modelOrigin[index].setting
                                )
                            "
                            >Save setting for
                            {{ getOriginName(data.origin_id) }}</el-button
                        >
                    </div>
                </div>
            </template>
        </el-form-item>
        <el-form-item label="Contact email">
            <el-input v-model="model.general_setting.contact_email"></el-input>
        </el-form-item>
        <el-form-item label="BCC email">
            <el-input v-model="model.general_setting.bcc_email"></el-input>
            <template v-for="(data, index) in modelOrigin">
                <div
                    v-if="
                        data.setting_key === 'bcc_email' &&
                        origins.length &&
                        isValidOrigin(data.origin_id)
                    "
                    class="mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
                >
                    <div class="flex">
                        <div class="grow-0 shrink-0 basis-32">
                            Setting for {{ getOriginName(data.origin_id) }}
                        </div>
                        <el-input
                            v-model="modelOrigin[index].setting"
                        ></el-input>
                    </div>
                    <div class="flex justify-end mt-4">
                        <el-button
                            type="primary"
                            @click="
                                onSubmitOriginSetting(
                                    data.id,
                                    modelOrigin[index].setting
                                )
                            "
                            >Save setting for
                            {{ getOriginName(data.origin_id) }}</el-button
                        >
                    </div>
                </div>
            </template>
        </el-form-item>
        <el-form-item label="Stock alert email">
            <el-input
                v-model="model.general_setting.stock_alert_emails"
            ></el-input>
        </el-form-item>
        <el-form-item label="Stock alert trigger">
            <el-input
                v-model="model.general_setting.stock_alert_email_trigger"
            ></el-input>
        </el-form-item>
        <el-form-item label="Activate new customers">
            <el-radio
                v-model="model.general_setting.new_customer_status"
                label="1"
                >Yes</el-radio
            >
            <el-radio
                v-model="model.general_setting.new_customer_status"
                label="0"
                >No</el-radio
            >
        </el-form-item>
        <el-form-item label="Logo URL">
            <el-input v-model="model.general_setting.site_logo"></el-input>
            <template v-for="(data, index) in modelOrigin">
                <div
                    v-if="
                        data.setting_key === 'site_logo' &&
                        origins.length &&
                        isValidOrigin(data.origin_id)
                    "
                    class="mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
                >
                    <div class="flex">
                        <div class="grow-0 shrink-0 basis-32">
                            Setting for {{ getOriginName(data.origin_id) }}
                        </div>
                        <el-input
                            v-model="modelOrigin[index].setting"
                        ></el-input>
                    </div>
                    <div class="flex justify-end mt-4">
                        <el-button
                            type="primary"
                            @click="
                                onSubmitOriginSetting(
                                    data.id,
                                    modelOrigin[index].setting
                                )
                            "
                            >Save setting for
                            {{ getOriginName(data.origin_id) }}</el-button
                        >
                    </div>
                </div>
            </template>
        </el-form-item>
        <el-form-item label="Company name">
            <el-input v-model="model.general_setting.company_name"></el-input>
            <template v-for="(data, index) in modelOrigin">
                <div
                    v-if="
                        data.setting_key === 'company_name' &&
                        origins.length &&
                        isValidOrigin(data.origin_id)
                    "
                    class="mt-4 p-4 border rounded border-gray-500 border-solid w-1/2 ml-auto"
                >
                    <div class="flex">
                        <div class="grow-0 shrink-0 basis-32">
                            Setting for {{ getOriginName(data.origin_id) }}
                        </div>
                        <el-input
                            v-model="modelOrigin[index].setting"
                        ></el-input>
                    </div>
                    <div class="flex justify-end mt-4">
                        <el-button
                            type="primary"
                            @click="
                                onSubmitOriginSetting(
                                    data.id,
                                    modelOrigin[index].setting
                                )
                            "
                            >Save setting for
                            {{ getOriginName(data.origin_id) }}</el-button
                        >
                    </div>
                </div>
            </template>
        </el-form-item>
    </div>
</template>

<script>
export default {
    props: ['model', 'modelOrigin', 'rootConfig'],

    data() {
        return {
            origins: [],
            loading: true,
        };
    },

    created() {
        this.$resource(
            this.rootConfig.endPoint + '/origins',
            {},
            {},
            { headers: this.rootConfig.headers }
        )
            .get()
            .then((res) => {
                this.loading = false;
                this.origins = res.data;
            });
    },

    methods: {
        isValidOrigin(origin_id) {
            return this.origins.find((origin) => origin.id === origin_id);
        },
        getOriginName(origin_id) {
            return this.origins.find((origin) => origin.id === origin_id).name;
        },
        onSubmitOriginSetting(id, setting) {
            const data = { id, setting };
            this.$resource(
                this.rootConfig.endPoint + '/settings/{id}',
                {},
                {},
                { headers: this.rootConfig.headers }
            )
                .update({ id }, data)
                .then(() => {
                    this.$message('Updated successfully');
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// General.vue?7c6dec76